import { Component, Input, OnInit } from '@angular/core';
import { Package } from 'src/app/micro-services/packages/models/package';
import { ESubscriptionType } from 'src/app/micro-services/subscription/enum/e-subscription-type';
import { SubscriptionFactoryService } from 'src/app/micro-services/subscription/services/subscription-factory.service';
import { PaymentFlowEventsEnum, PaymentSheetEventsEnum, Stripe } from '@capacitor-community/stripe';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-select-package',
  templateUrl: './select-package.component.html',
  styleUrls: ['./select-package.component.scss'],
})
export class SelectPackageComponent implements OnInit {

  @Input() pack : Package;
  @Input() recurrence : string;

  processSheet: 'willReady' | 'Ready' = 'willReady';
  processFlow: string;

  constructor(
    private subServiceFactory : SubscriptionFactoryService,
    private readonly modalCtrl : ModalController
  ) {

  }

  async ngOnInit() {
    Stripe.addListener(PaymentSheetEventsEnum.Loaded, () => {
      this.processSheet = 'Ready';
    });

    Stripe.addListener(PaymentSheetEventsEnum.FailedToLoad, () => {
    });

    Stripe.addListener(PaymentSheetEventsEnum.Completed, () => {
      this.processSheet = 'willReady';
    });

    Stripe.addListener(PaymentSheetEventsEnum.Canceled, () => {
      this.processSheet = 'willReady';
    });

    Stripe.addListener(PaymentSheetEventsEnum.Failed, () => {
      this.processSheet = 'willReady';
    });
  }

  choosePlan(){

    this.subServiceFactory.create(ESubscriptionType.Plateform).getStripeSessionToCheckout(this.pack).subscribe({
      next : async (subscription : any) => {
        //window.location.href = stripeSessionCheckout.url;
        await Stripe.createPaymentSheet({
          paymentIntentClientSecret: subscription.latest_invoice.payment_intent.client_secret,
          customerId: subscription.customer,
          withZipCode : false
        });

        await new Promise((resolve) => setTimeout(resolve, 2500));



        let result = await Stripe.presentPaymentSheet();

        this.modalCtrl.dismiss(null,"confirm");

      },
      error : (err) => {
        
      }
    })
  }

  presentPaymentSheet() {
    return Stripe.presentPaymentSheet();
  }
  
}
